import Cookies from "js-cookie";
import { useMemo } from "react";
import { useFetchLanguageList } from "../store/api/useFetchLanguageList";
import {
  MapProvider,
  resolveMapProvider,
} from "../utils/mapProvider";

export function useMapProvider(): {
  provider: MapProvider;
  languageName: string;
  isYandex: boolean;
} {
  const { data: languageListRes } = useFetchLanguageList();
  const languageId = Cookies.get("language_id");

  return useMemo(() => {
    const currentLanguage = (languageListRes?.data?.Records ?? []).find(
      (language) => language.language_id.toString() === languageId,
    );
    const languageName =
      currentLanguage?.language ||
      (typeof navigator !== "undefined" ? navigator.language : "") ||
      "";
    const provider = resolveMapProvider(languageName);
    return {
      provider,
      languageName,
      isYandex: provider === "yandex",
    };
  }, [languageListRes?.data?.Records, languageId]);
}
